import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import ApartmentsSection from "@/components/ApartmentsSection";
import Footer from "@/components/Footer";

export default function Home() {
  useEffect(() => {
    document.title =
      "Kenneth Nathanael Lukman LLC — Boutique Property Consultancy";
  }, []);

  return (
    <div data-testid="page-home" className="min-h-screen bg-[#F7F3EA]">
      <Navbar />
      <main>
        <Hero />
        <ApartmentsSection />
        <About />
      </main>
      <Footer />
    </div>
  );
}
